import { Column } from "react-table";
import {
  GetComplianceInvestigationLikelyCausesFetchUrl,
  IComplianceInvestigationLikelyCause,
} from "../../api/ComplianceInvestigation/IComplianceInvestigationLikelyCause";
import { Grid } from "../Grid";
import { ComplianceInvestigationLikelyCausesGridProps } from "./ComplianceInvestigationLikelyCausesGridProps";

const ComplianceInvestigationLikelyCausesGrid = ({
  complianceInvestigationId,
  licenceProfile,
}: ComplianceInvestigationLikelyCausesGridProps) => {
  const getFetchUrlFactory = (relatedId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      return GetComplianceInvestigationLikelyCausesFetchUrl(
        relatedId,
        pageNo,
        recordsPerPage,
        searchText,
        filters
      );
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory(complianceInvestigationId);

  const tableColumnsBig: Column<
    Record<string, IComplianceInvestigationLikelyCause>
  >[] = [
    {
      Header: "Likely Cause",
      accessor: "cause",
      Filter: false,
    },
    {
      Header: "Description",
      accessor: "description",
      Filter: false,
      filter: "includes",
    },
  ];

  const tableColumnsSmall: Column<
    Record<string, IComplianceInvestigationLikelyCause>
  >[] = [
    {
      Header: "Likely Cause",
      accessor: "cause",
      Filter: false,
    },
  ];

  var bodyElements = (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
    </div>
  );

  return bodyElements;
};

export { ComplianceInvestigationLikelyCausesGrid };
